import axios from 'axios';

import { IAdvertisementType } from '@/shared/model/advertisement-type.model';

const baseApiUrl = 'api/advertisement-types';
const apiGetAdvertisementTypeByType = 'api/advertisement-types/type';

export default class AdvertisementTypeService {
  public find(id: number): Promise<IAdvertisementType> {
    return new Promise<IAdvertisementType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAdvertisementType): Promise<IAdvertisementType> {
    return new Promise<IAdvertisementType>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAdvertisementType): Promise<IAdvertisementType> {
    return new Promise<IAdvertisementType>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAdvertisementTypeByType(type: string): Promise<IAdvertisementType> {
    return new Promise<IAdvertisementType>((resolve, reject) => {
      axios
        .get(`${apiGetAdvertisementTypeByType}/${type}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
